import { getNumberFromString } from './formatNumbers';

export default function getSum(...args) {
  const sum = args
    .filter((arg) => arg !== 'N/A')
    .reduce((a, b) => {
      if (typeof b === 'string') {
        return a + getNumberFromString(b);
      } else {
        return a + b;
      }
    }, 0);

  const rounded = Math.round(sum * 100) / 100;

  return rounded;
}
